import React from 'react';
import styles from './styles/styles.module.scss';
import BelayFacebookButton from '../../../buttons/BelayFacebookButton';
import ActionCardBase from '../ActionCardBase';

const FacebookActionCard = () => {
  return (
    <ActionCardBase
      className={styles.container}
      imgSrc="https://cdn-assets.alltrails.com/assets/icons/facebook.svg"
      text="Facebook"
      button={<BelayFacebookButton buttonClassName={styles.button} />}
    />
  );
};

export default FacebookActionCard;
